import { RichText } from '#components/base/RichtText/RichtText';

import styles from './BoardSectionItemRichText.module.scss';

type Props = {
	introduction?: {
		title: string | null | undefined;
		text: string | null | undefined;
	};
};
export function BoardSectionItemRichText({ introduction }: Props) {
	return introduction ? (
		<div className={styles.textDiv}>
			<div className={styles.innerDiv}>
				<h2 className={styles.headline}>{introduction.title}</h2>
				<RichText className="body4" text={introduction.text} />
			</div>
		</div>
	) : null;
}
